"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCancelButton = exports.useCancelButtonProps = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var model_1 = require("../../../../../model");
/**
 * @internal
 */
function useCancelButtonProps() {
    var dispatch = model_1.useDashboardDispatch();
    var isEditing = model_1.useDashboardSelector(model_1.selectIsInEditMode);
    var isSaving = model_1.useDashboardSelector(model_1.selectIsDashboardSaving);
    var isDirty = model_1.useDashboardSelector(model_1.selectIsDashboardDirty);
    var onCancelClick = react_1.useCallback(function () {
        if (isDirty) {
            dispatch(model_1.uiActions.openCancelEditModeDialog());
        }
        else {
            dispatch(model_1.cancelEditRenderMode());
        }
    }, [dispatch, isDirty]);
    return {
        isVisible: isEditing && !isSaving,
        onCancelClick: onCancelClick,
    };
}
exports.useCancelButtonProps = useCancelButtonProps;
/**
 * @internal
 */
function DefaultCancelButton(_a) {
    var isVisible = _a.isVisible, onCancelClick = _a.onCancelClick;
    var intl = react_intl_1.useIntl();
    if (!isVisible) {
        return null;
    }
    return (react_1.default.createElement(sdk_ui_kit_1.Button, { className: "gd-button-secondary cancel-button s-cancel_button", value: intl.formatMessage({ id: "cancel" }), onClick: onCancelClick }));
}
exports.DefaultCancelButton = DefaultCancelButton;
//# sourceMappingURL=DefaultCancelButton.js.map